import Vue from "vue";
import App from "./App.vue";
import LayoutHome from "./components/LayoutHome.vue";
import store from "./store";
import "./registerServiceWorker";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import PortalVue from "portal-vue";
import VueMeta from "vue-meta";
import dayjs from "dayjs";
import "dayjs/locale/nl";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import VueRouter from "vue-router";

const firebase = require("firebase/app");
require("firebase/messaging");

dayjs.extend(LocalizedFormat);
dayjs.locale("nl");
Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs });

var config = {
  apiKey: "AIzaSyCIPG3urWrjAdedD4hx2eNzibCrJo21RDU",
  authDomain: "api-7505019477374111882-459984.firebaseapp.com",
  databaseURL: "https://api-7505019477374111882-459984.firebaseio.com",
  projectId: "api-7505019477374111882-459984",
  storageBucket: "api-7505019477374111882-459984.appspot.com",
  messagingSenderId: "423379283040"
};

firebase.initializeApp(config);

if (firebase.messaging.isSupported()) {
  Vue.prototype.$messaging = firebase.messaging();
}

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: false
});

Vue.config.productionTip = false;

Vue.use(firebase);
Vue.use(VueRouter);
Vue.use(PortalVue);

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  release: process.env.VUE_APP_SENTRY_RELEASE,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true
    })
  ]
});

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/positions/:id", component: LayoutHome },
    { path: "/gemeentes/:id", component: LayoutHome }
  ]
});

new Vue({
  store,
  render: h => h(App),
  firebase: firebase,
  router
}).$mount("#app");
